
import React from 'react';

interface VacationMascotProps {
  size?: 'small' | 'large';
}

export const VacationMascot = ({ size = 'large' }: VacationMascotProps) => {
  const sizeClasses = size === 'small' ? 'h-16 w-16' : 'h-32 w-32 md:h-40 md:w-40';
  
  return (
    <div className="flex justify-center">
      <img 
        src="/lovable-uploads/a9f04768-7126-4fab-9aa7-51871b6e2355.png" 
        alt="Zonnie Vakantie Mascot" 
        className={sizeClasses}
      />
    </div>
  );
};
